import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  IntegrationCard as StyledCard,
  IntegrationCardHeader,
  IntegrationCardIcon,
  IntegrationCardInfo,
  IntegrationCardName,
  IntegrationCardStatus,
  IntegrationCardDescription,
  IntegrationPreview,
  PreviewIcon
} from './styles';

interface Integration {
  name: string;
  icon: string;
  available: boolean;
  angle: number;
  description: string;
  features: string[];
}

interface IntegrationCardProps {
  integration: Integration;
  isVisible: boolean;
  delay: number;
}

const IntegrationCard: React.FC<IntegrationCardProps> = ({
  integration,
  isVisible,
  delay
}) => {
  const { t } = useTranslation();

  return (
    <StyledCard
      $isVisible={isVisible}
      $delay={delay}
      $available={integration.available}
    >
      <IntegrationCardHeader>
        <IntegrationCardIcon $available={integration.available}>
          <img
            src={integration.icon}
            alt={integration.name}
            loading="lazy"
            decoding="async"
            width="48"
            height="48"
          />
        </IntegrationCardIcon>
        <IntegrationCardInfo>
          <IntegrationCardName $available={integration.available}>
            {integration.name}
          </IntegrationCardName>
          <IntegrationCardStatus $available={integration.available}>
            {integration.available ? t('integrations.available') : t('integrations.comingSoon')}
          </IntegrationCardStatus>
        </IntegrationCardInfo>
      </IntegrationCardHeader>
      <IntegrationCardDescription>
        {integration.description}
      </IntegrationCardDescription>
      <IntegrationPreview $available={integration.available}>
        <PreviewIcon />
        {integration.available ? t('integrations.available') : t('integrations.comingSoon')}
      </IntegrationPreview>
    </StyledCard>
  );
};

export default IntegrationCard;
